export const selectScanPackSettings = state => {
  if (!state.user) return null;

  if (state.user.scanpackSettings?.data) {
    const data = state.user.scanpackSettings.data;
    if (data.settings && typeof data.settings === 'object') {
      return data.settings;
    }
    return data;
  }
  if (state.user.bothSettings?.data?.data?.scanpack_setting) {
    return state.user.bothSettings.data.data.scanpack_setting;
  }
  return null;
};

export const selectCanEditScanningPrefs = state => {
  const role = state?.user?.userInfo?.role;
  // Fail open while role data hasn't loaded — the API still enforces the permission
  if (!role) return true;
  return role.make_super_admin === true || role.edit_scanning_prefs === true;
};

export const selectZoneAccessSource = state => {
  if (!state || !state.user) return 'user';
  if (state.user.scanpackSettings?.data?.zone_access_source) {
    return state.user.scanpackSettings.data.zone_access_source;
  }
  if (state.user.scanpackSettings?.data?.settings?.zone_access_source) {
    return state.user.scanpackSettings.data.settings.zone_access_source;
  }
  if (state.user.bothSettings?.data?.data?.scanpack_setting?.zone_access_source) {
    return state.user.bothSettings.data.data.scanpack_setting.zone_access_source;
  }
  return 'user';
};
